/**
 *  AOEPowerup
 *
 *  Created by Legman on 25/04/2017.
 *
 */

import AOE from "./AOE";
import Powerup from "./Powerup";


/**
 * @class
 * @extends Powerup
 */
export default class AOEPowerup extends Powerup {
    /**
     * @param collector
     */
    constructor(collector) {
        super(collector);

        /**
         * @type {AOE}
         * @protected
         */
        this._aoe = null;
    }

    /**
     * @param {number} dt
     */
    update(dt) {
        super.update(dt);

        if (this._aoe) {
            this._aoe.update(dt);
            if (!this._aoe.parent) {
                this.destroyNextFrame = true;
            }
        }
    }

    /**
     * @returns {AOE}
     */
    get aoe() {
        return this._aoe;
    }
}